import(/* webpackMode: "eager", webpackExports: ["ProductPageWrapper"] */ "/home/runner/_work/holibob/holibob/booking-web/app/[locale]/product/[input]/ProductPageWrapper.tsx");
